import React, { Fragment } from "react";
import Drawer from "react-motion-drawer";
import PerfectScrollbar from "react-perfect-scrollbar";
import ServerDetails from "./TabsContent/ServerDetails";

class HeaderRightDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      openRight: false,
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  /*********************************** LIFECYCLE ***********************************/

  render() {
    const { openRight } = this.state;

    if (this._isMounted || true) {
      return (
        <Fragment>
          <Drawer
            right
            className="drawer-content-wrapper p-0"
            width={450}
            open={openRight}
            onChange={open => this.setState({ openRight: open })}
            noTouchOpen={false}
            noTouchClose={false}
          >
            <PerfectScrollbar>
              <div className="drawer-nav-btn">
                <button class="hamburger hamburger--elastic is-active" type="button" onClick={()=>{
                  this.setState({openRight:false})}}>
                  <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                  </span>
                </button>
              </div>

              <ServerDetails />
            </PerfectScrollbar>
          </Drawer>

          <div className="header-btn-lg">
            <button class="hamburger hamburger--collapse is-active" type="button" onClick={()=>{
              this.setState({openRight:true})}}>
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </Fragment>
      );
    } else {
    }
  }
}

export default HeaderRightDrawer;



// WEBPACK FOOTER //
// ./src/Layout/AppHeader/Components/HeaderRightDrawer.js